<footer class="footer-main" [class.pag-inicial]="paginaInicial">
  <div class="container">
    <div class="footer-text">
      <div class="ratings" [class.pag-inicial]="paginaInicial">
        <a
          rel="noopener"
          href="https://web.iarcservices.com/Dashboard/Certificate/ba2d6700-4346-4810-9b7f-e8e349d3b8e3"
          id="iarc"
          target="_blank">
          <img class="classif-logo" alt="Classificação Livre" src="img/ClassInd_L.png" />
        </a>
        <a rel="noopener" href="http://creativecommons.org/licenses/by/4.0/" target="_blank">
          <img class="cc-logo" alt="Licença Creative Commons" src="img/cc_by_1.png" />
        </a>
      </div>
    </div>
    <div class="footer-text">
      <span>
        <a routerLink="/privacy" class="privacy">Política de Privacidade</a>
      </span>
    </div>
    <div class="footer-icons" [class.pag-inicial]="paginaInicial">
      <ul class="c-footer-icons" [class.social-small]="!paginaInicial">
        <li class="sr-footer-icons">
          <a
            href="https://instagram.com/bolco2026/"
            (click)="logEvent('instagram')"
            aria-label="Instagram: @bolco2026"
            target="_blank"
            rel="noopener noreferrer">
            <svg viewBox="0 0 1 1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#instagram"></use></svg
          ></a>
        </li>
        <li class="sr-footer-icons">
          <a
            href="https://twitter.com/bolco2026/"
            (click)="logEvent('twitter')"
            aria-label="Twitter: @bolco2026"
            target="_blank"
            rel="noopener noreferrer">
            <svg viewBox="0 0 1 1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#twitter"></use></svg
          ></a>
        </li>
      </ul>
    </div>
    <div class="footer-version" [class.pag-inicial]="paginaInicial">
      <span>{{ version }}</span>
    </div>
  </div>
</footer>
<svg xmlns="http://www.w3.org/2000/svg" style="display: none">
  <defs>
    <symbol id="instagram" viewBox="0 0 16 16">
      <title>Instagram</title>
      <path
        d="M7.93,11.25A3.1,3.1,0,0,0,11,8.15,3.07,3.07,0,0,0,10,5.8,3,3,0,0,0,7.93,5a3.18,3.18,0,0,0-1.32.27,3.44,3.44,0,0,0-.76.5,3.11,3.11,0,0,0,2.08,5.45Zm0-5.41a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3Zm3.45.24h4.48v6.8A3.12,3.12,0,0,1,12.74,16H3.16A3.16,3.16,0,0,1,0,12.88V6.08H4.46a4,4,0,0,0-.57,2.06A4,4,0,1,0,12,8.47V8.14A4,4,0,0,0,11.38,6.08ZM12.74.14H4.63v3.3H4V.14H3.31v3.3H2.64V.19A2.71,2.71,0,0,0,2,.37V3.44H1.32V.73A3.11,3.11,0,0,0,0,3.26V5.42H4.94a4,4,0,0,1,5.69-.25l.26.25h5V3.26A3.11,3.11,0,0,0,12.74.14Zm1.8,3.47a.49.49,0,0,1-.49.49H12.39a.49.49,0,0,1-.49-.49h0V1.94a.48.48,0,0,1,.49-.48h1.66a.48.48,0,0,1,.49.48h0Z" />
    </symbol>
    <symbol id="twitter" viewBox="0 0 16 16">
      <title>Twitter</title>
      <path
        d="M14.367 4.734v.43c0 4.336-3.297 9.336-9.328 9.336-1.853 0-3.595-.406-5.04-1.336.258.04.516.055.78.055 1.532 0 2.962-.665 4.072-1.556-1.422-.016-2.65-.984-3.055-2.28.203.038.406.06.61.06.296 0 .593-.038.874-.116C1.78 9.03.65 7.703.65 6.108V6.07c.446.242.946.39 1.485.407-.89-.594-1.47-1.594-1.47-2.72 0-.61.173-1.11.446-1.593C2.74 4.148 5.147 5.384 7.866 5.53c-.055-.233-.07-.5-.07-.757 0-1.812 1.46-3.273 3.273-3.273.946 0 1.797.406 2.414 1.03.735-.147 1.446-.42 2.07-.796-.242.766-.757 1.414-1.445 1.82.67-.077 1.296-.257 1.89-.523-.445.673-1 1.243-1.633 1.704z" />
    </symbol>
  </defs>
</svg>
